import { render, staticRenderFns } from "./Prestamos.vue?vue&type=template&id=392f87a9&scoped=true"
import script from "./Prestamos.vue?vue&type=script&lang=js"
export * from "./Prestamos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392f87a9",
  null
  
)

export default component.exports